import { SupportMessage } from '@bridebook/aura';
import { TriangleWarning } from '@bridebook/aura/src/icons';
import { ContactsFilter, GUEST_FILTER_DEFAULT } from '@bridebook/web/lib/guestlist/constants';
import { getGuests, getGuestsMissingEmail } from '@bridebook/web/lib/guestlist/selectors';
import { interactedWithGuestCommsAction } from '@bridebook/web/lib/inbox/guests/analytics/actions';
import { useConfirmExitFlowModal } from '@bridebook/web/lib/inbox/guests/create-message-flow/use-confirm-exit-flow-modal';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useDispatch, useSelector } from '@bridebook/web/lib/utils';
import { Trans, useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

export const MissingEmailsBanner = () => {
  const guests = useSelector(getGuests);
  const missingEmailsCount = useSelector(getGuestsMissingEmail);
  const { push } = useRouter();
  const dispatch = useDispatch();
  const closeWithConfirmation = useConfirmExitFlowModal();
  if (missingEmailsCount === 0) {
    return null;
  }

  const handleClick = () => {
    closeWithConfirmation(() => {
      dispatch(
        interactedWithGuestCommsAction({
          action: 'clicked',
          location: 'guestComms',
          section: 'selectRecipients',
          element: 'missingEmailsBanner',
          elementLabel: 'Leave anyway',
        }),
      );
      push(
        UrlHelper.guestlist.withFilters({
          ...GUEST_FILTER_DEFAULT,
          contacts: ContactsFilter.emailMissing,
        }),
      );
    });
  };

  return (
    <>
      <div className="pt-4 xl:pt-0">
        <MissingEmailsBannerContent
          count={missingEmailsCount}
          total={guests.length}
          onClick={handleClick}
        />
      </div>
    </>
  );
};

const MissingEmailsBannerContent = ({
  count,
  total,
  onClick,
}: {
  count: number;
  total: number;
  onClick: () => void;
}) => {
  const { t } = useTranslation('inbox');

  return (
    <SupportMessage
      theme="warning"
      icon={TriangleWarning}
      title={t('guests.missingEmailsBanner.title', {
        count,
        total,
      })}
      onClick={onClick}>
      <Trans ns="inbox" i18nKey="guests.missingEmailsBanner.description">
        <span className="text-indigo-crush">View list</span> and add missing emails
      </Trans>
    </SupportMessage>
  );
};
